import React, { useState, useEffect } from "react";

// Same "Open Submissions" KPI as CountryRegistrationsDashboard.js's own KPI grid — same
// source endpoint, same trend calculation — just reused here so it also shows on the
// Submissions page and the cross-submission Q&A list, not only the main dashboard. There's
// no dedicated "just this one count" endpoint; the dashboard endpoint returns several stats
// at once and this only reads the two Open Submissions fields off it, same as the dashboard
// page itself does.
// selected: true when this card represents the page currently being viewed. Uses the exact
// same submenu-card/submenu-card-selected classes DataTable.js's own SubMenuCM renders with
// (Shared/App.css) — see the same note on SubmissionQAKpiCard.js.
//
// Renders just the <a> card itself, not its own .submenu-grid wrapper — see
// SubmissionQAKpiCard.js for why (matching SubMenuCM's own single-shared-grid structure).
const OpenSubmissionsKpiCard = ({ selected = false }) => {

    const [value, setValue] = useState(null);
    const [trendValue, setTrendValue] = useState(null);
    let currentLegalManufacturerFilter = window.legalManufacturerId;
    useEffect(() => {
        fetch('/umbraco/api/RIMSRegistrations/Dashboard/?legalManufacturerId=' + currentLegalManufacturerFilter)
            .then((response) => response.ok ? response.json() : null)
            .then((data) => {
                if (!data) return;
                setValue(data.OpenSubmissions);
                if (data.OpenSubmissionsVariability != null)
                    setTrendValue(Math.round(data.OpenSubmissionsVariability));
            })
            .catch((error) => console.log("error: " + error));
    }, []);

    const hasTrend = trendValue != null && !isNaN(trendValue);
    const trendColor = !hasTrend ? "" : trendValue > 0 ? "#48bb78" : trendValue < 0 ? "#e53e3e" : "#a0aec0";
    const trendIcon = !hasTrend ? "" : trendValue > 0 ? "fa-arrow-up" : trendValue < 0 ? "fa-arrow-down" : "fa-minus";
    const trendText = hasTrend ? `${trendValue > 0 ? "+" : ""}${trendValue}% this month` : "";
    
    return (
        <a href="/your-medboard/country-registrations/submissions/" className={`submenu-card qa-kpi-card ${selected ? "submenu-card-selected" : ""}`}>
            <span className="submenu-title">Open Submissions</span>
            <div className="submenu-value-row">
                <i className="fas fa-file-import submenu-icon"></i>
                <span className="submenu-value" style={{ color: "rgb(85, 85, 85)" }}>{value ?? "…"}</span>
                {/* No submenu-* equivalent for this trend subtext — SubMenuCM's own cards
                    don't have one — so it stays a small inline-styled addition rather than
                    a shared class. */}
                {hasTrend && (
                    <span style={{ fontSize: "11px", fontWeight: 600, color: trendColor }}>
                        <i className={`fas ${trendIcon}`} style={{ marginRight: "4px" }} />
                        {trendText}
                    </span>
                )}
            </div>
        </a>
    );
};

export default OpenSubmissionsKpiCard;
